// @flow

import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { Link }   from 'react-router-dom';
import { getTranslate }     from 'react-localize-redux';
import { getOfferView }     from 'actions/offer/offer';
import moment               from 'moment';
import Dropzone             from 'react-dropzone';
import ReactLoading         from 'react-loading';
import Slider               from 'react-slick';
import { getCreds, uploadFile, saveAttachment, getFile } from 'actions/s3/fileUpload';
import { setTitle }         from 'actions/common/navigation';
import { setFlash, clearFlash } from 'actions/common/flash';
import documentHelper       from 'helpers/document.helper';
import urlHelper            from 'helpers/url.helper';
import toolHelper           from 'helpers/tools.helper';
import DirectOffer          from '../InsuranceInquiry/directOffer';
import { createStat }       from 'actions/directOffers';
import './index.css';

class CompanyBranding extends Component {

  // Default offer webservice statuses
  OFFER_WEBSERVICE_STATUS = {
    empty    : 'empty',
    success  : 'success',
    rejected : 'rejected'
  };

  correctValue(val, products_count) {
    return products_count > val ? val : products_count;
  }

  RESPONSIVE_SLIDE_COUNT = {
    'default': 7,
    '1400': 6,
    '1200': 5,
    '1024': 4,
    '768': 3,
    '480': 2
  }

  // Slider settings
  returnSlickSettings(products_count) {
    return  {
      infinite : false,
      arrows   : false,
      dots     : products_count > this.RESPONSIVE_SLIDE_COUNT['default'],
      slidesToShow  : this.correctValue(this.RESPONSIVE_SLIDE_COUNT['default'], products_count),
      slidesToScroll: this.correctValue(this.RESPONSIVE_SLIDE_COUNT['default'], products_count),
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow  : this.correctValue(this.RESPONSIVE_SLIDE_COUNT['1400'], products_count),
            slidesToScroll: this.correctValue(this.RESPONSIVE_SLIDE_COUNT['1400'], products_count),
            dots: products_count > this.RESPONSIVE_SLIDE_COUNT['1400']
          }
        },{
          breakpoint: 1200,
          settings: {
            slidesToShow: this.correctValue(this.RESPONSIVE_SLIDE_COUNT['1200'], products_count),
            slidesToScroll: this.correctValue(this.RESPONSIVE_SLIDE_COUNT['1200'], products_count),
            dots: products_count > this.RESPONSIVE_SLIDE_COUNT['1200']
          }
        },{
          breakpoint: 1024,
          settings: {
            slidesToShow: this.correctValue(this.RESPONSIVE_SLIDE_COUNT['1024'], products_count),
            slidesToScroll: this.correctValue(this.RESPONSIVE_SLIDE_COUNT['1024'], products_count),
            dots: products_count > this.RESPONSIVE_SLIDE_COUNT['1024']
          }
        },{
          breakpoint: 768,
          settings: {
            slidesToShow: this.correctValue(this.RESPONSIVE_SLIDE_COUNT['768'], products_count),
            slidesToScroll: this.correctValue(this.RESPONSIVE_SLIDE_COUNT['768'], products_count),
            dots: products_count > this.RESPONSIVE_SLIDE_COUNT['768']
          }
        },{
          breakpoint: 480,
          settings: {
            slidesToShow: this.RESPONSIVE_SLIDE_COUNT['480'],
            slidesToScroll: this.RESPONSIVE_SLIDE_COUNT['480'],
            dots: products_count > this.RESPONSIVE_SLIDE_COUNT['480']
          }
        }
      ]
    }
  }

  activity_logs = [];
  initial_log   = {
    id                  : 0,
    translated_activity : undefined,
    look                : 'first-open',
    created_at          : undefined,
    primary_status      : 0,
    secondary_status    : 0,
    access_stats        : [0,0,0,0,0,0]
  };
  // Condition engine log
  ce_log = {
    id                  : 0,
    translated_activity : undefined,
    look                : 'first-open',
    created_at          : undefined,
    primary_status      : 0,
    secondary_status    : 0,
    access_stats        : [0,0,0,0,0,0]
  };
  // Application Company ID
  applicationCompanyID = 0;

  // Company Application ID
  offer_company_id = 0;

  state = {
    offer: {
      loading: true,
      row    : {}
    },
    dropzone: {
      accepted: null,
      rejected: null
    }
  };

  constructor(props) {
    super(props);
    const { translate, dispatch } = props;

    // Reset flash messages
    dispatch(clearFlash());

    // Default translated activity for CE log
    this.ce_log.translated_activity = translate('companybranding.ce_logs.match');

    this._getFile = this._getFile.bind(this);
  }

  componentDidMount() {
    const { match: { params: { companyAppId } } } = this.props;

    // Get ID from state passed through URLs
    this.offer_company_id = Number(companyAppId);
    this._mapOfferToState();
  }

  _createDirectOfferStat = (application_company_id: number, webservice_id: number, event_type: string, webservice_name: string) => {
    const { dispatch } = this.props;

    dispatch(createStat(application_company_id, webservice_id, event_type));
  }

  render() {
    const { props: { translate }, state: { offer: { loading, row: { offer, products } }, dropzone: { accepted } } } = this;
    const { currentApp } = this.props;
    let offerProducts       = [];
    let uniqueSellingPoints = [];
    let openingHours        = [];
    let current_day_number  = new Date().getDay() === 0 ? 7 : new Date().getDay();
    this.activity_logs      = [];
    const usp_breakpoint = 3;

    if( loading === false ) {
      // Set document title
      documentHelper.setTitle(translate('companybranding.title') + ' ' + offer.company.meta_name);

      this.activity_logs = [];

      // Add all other activity logs
      const { ows_activity_logs } = offer;
      if( ows_activity_logs && ows_activity_logs.length ) {
        ows_activity_logs.map( (item, index) => {
          const { secondary_status, look, activity } = item;
          let log = item;

          if( !(secondary_status === 8 || look === '' || activity === 'Vundet emne') ) {
            if( secondary_status === 5 ) {
              if( log.details !== null ) {
                // Follow up has date > was on calendar
                log['translated_activity'] = translate('companybranding.ows_activity_logs.planned_follow_up') + ' ' + moment(item.details).format('dd/mm (HH:MM)');
              } else {
                // Follow up has no date > was on button press
                log['translated_activity'] = translate('companybranding.ows_activity_logs.no_follow_up_date');
                log['look'] = 'glyphicon glyphicon-phone text-green';
              }
            } else {
              log['translated_activity'] = translate('companybranding.activity.' + log.activity);
            }

            if( this.activity_logs[index] !== log ) {
              this.activity_logs.push(log);
            }
          }
          return true;
        });
      } else {
        // Add info logs if no "real" actions are taken yet
        if( this._offerStatusCheck(this.OFFER_WEBSERVICE_STATUS.success) ) {
          if( accepted === null ) {
            this.initial_log = {
              ...this.initial_log,
              created_at          : offer.primary_webservice_status.time,
              translated_activity : translate('companybranding.initial_logs.offer_status_success'),
              look                : 'lead-won'
            };
            this.activity_logs.push(this.initial_log);
          }
        } else if( this._offerStatusCheck(this.OFFER_WEBSERVICE_STATUS.rejected) ) {
          if( accepted === null ) {
            this.initial_log = {
              ...this.initial_log,
              created_at          : offer.primary_webservice_status.time,
              translated_activity : translate('companybranding.initial_logs.offer_status_rejected'),
              look                : 'lead-lost',
              access_stats        : [0,0,0,0,0,7]
            };
            this.activity_logs.push(this.initial_log);
          }
        }

        // Add condition engine log to activity logs
        this.ce_log = { ...this.ce_log, created_at: offer.created_at };
        if( accepted === null ) {
          this.activity_logs.push(this.ce_log);
        }
      }

      // Offer products
      if( products ) {
        offerProducts = products;
      }

      // Prepare additional data
      uniqueSellingPoints = offer.company.unique_selling_points.split('\n');

      openingHours = offer.company.meta_opening_hours;
      if( openingHours ) {
        openingHours = openingHours.split('\n');
      }

      // Set application company ID
      this.applicationCompanyID = offer.id;
    }

    let uniqueSellingPointsOdds = [];
    let uniqueSellingPointsEven = [];

    if (uniqueSellingPoints.length > usp_breakpoint) {
      uniqueSellingPoints.map((item, i) => {
        if ( (i + 2) % 2 === 0 ) {
           return uniqueSellingPointsOdds.push(item);
         } else {
           return uniqueSellingPointsEven.push(item);
         }
       }
     )
    }

    // Company banner and logo
    let company_logo   = loading === false && offer.company.meta_logo_attached ? urlHelper.imageUrl(offer.company.meta_logo_large) : '';
    let company_banner = loading === false && offer.company.meta_banner_attached ? urlHelper.imageUrl(offer.company.meta_banner_large) : '';

    let saling_point_content = this._renderUSPList(uniqueSellingPoints, offer)

    let saling_point_content_two_row = (
      <div>
        {this._renderUSPList(uniqueSellingPointsOdds, offer)}
        {this._renderUSPList(uniqueSellingPointsEven, offer)}
      </div>
    )

    let saling_points = (
      <div className="unique-selling-point-container">
        {uniqueSellingPoints.length > usp_breakpoint ? saling_point_content_two_row : saling_point_content}
      </div>
    )

    let appCompany;
    const app = currentApp.applications.rows.find((item) => '"' + item.order_id + '"' === localStorage.getItem('app_current'));
    if (app && app.app_companies) {
      appCompany = app.app_companies.find((item) => item.id === this.applicationCompanyID);
    }

    return (
      <div className="company-branding">
        {loading === false &&
        <div className="general-info">
          <div className="clearfix">
            <article className="brand">
              {company_logo !== '' &&
              <div className="col-xs-12">
                <div className="image-holder">
                  <img src={company_logo} alt={offer.company.meta_name} className="img-responsive margin-center" />
                </div>
                <div className="clearfix"></div>
              </div>
              }

              <div className="clearfix"></div>
              <div className="top-bar">
                <div className="go-back">
                  <Link to={{ pathname: '/' }}>
                    <i className="fa fa-angle-left fa-lg"></i><span>{translate('companybranding.go_back')}</span>
                  </Link>
                </div>
                <div className="center-msg hidden-xs">
                  {translate('companybranding.about_company', { company: offer.company.meta_name })}
                </div>
                <div className="clearfix"></div>
              </div>

              {company_banner !== '' &&
              <div className="banner">
                <img src={company_banner} className="img-responsive" alt={offer.company.meta_name} />
              </div>
              }
              <div className="clearfix"></div>
            </article>

            <article className="unique-selling-points">
              {saling_points}

              {offerProducts &&
                <div className="company-products clearfix col-xs-12">
                  <div className="text-center">
                    <div className="strong-holder">
                      <h3>{translate('companybranding.offers_insurances')}</h3>
                      <div className="row offer-products">
                        <div className="carousel">
                          <Slider {...this.returnSlickSettings(offerProducts.length)}>
                          {offerProducts.map( (item, i) => {
                            return (
                              <div key={i} className="slide">
                                <a className="promo-box product-item">
                                  <figure>
                                    <div className="logo">
                                      <div className={'product-icon ' + item.url_alias}></div>
                                    </div>
                                    <figcaption>
                                      <h3>{item.name}</h3>
                                    </figcaption>
                                  </figure>
                                </a>
                              </div>
                            )})
                          }
                          </Slider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <div className="clearfix"></div>
            </article>
          </div>

          <section className="company-description">
            <div className="col-md-12">
              <h3>{translate('common.about')} {offer.company.meta_name}</h3>
              <div className="short-description"><p dangerouslySetInnerHTML={{__html: offer.company.meta_description_short}}></p></div>
              {offer.company.meta_description_detailed &&
                <div>
                  <div className="read-more">
                    <a data-toggle="collapse" className="collapsed" data-target="#collapseDetailed">
                      <span className="more">{translate('common.more')}</span><span className="less">{translate('common.less')}</span>
                    </a>
                  </div>
                  <div id="collapseDetailed" className="long-description collapse">
                    <p dangerouslySetInnerHTML={{__html: offer.company.meta_description_detailed}}></p>
                  </div>
                </div>
              }
            </div>

            <div className="clearfix"></div>
          </section>



          <section className="offer-info">
            <div className="col-xs-12 col-sm-6 col-md-6 mobile-pad">
              <div className="">
                <i className="fa fa-map-marker"></i>
                <div className="contact-info">
                  <h3>{translate('companybranding.contact_information')}</h3>
                  <div className="company-content">
                    <address dangerouslySetInnerHTML={{__html: offer.company.meta_address}}></address>
                  </div>
                  <div className="clearfix"></div>
                </div>
              </div>
              <div className="">
                <i className="fa fa-phone"></i>
                <div className="contact-info">
                  <div className="company-content">
                    <strong>{translate('companybranding.contact_information')}:</strong>

                    {offer.company.meta_phone !== '' &&
                      <div className="contact tel">
                        <a href={'tel:' + offer.company.meta_phone}>{offer.company.meta_phone}</a>
                      </div>
                    }

                    {offer.company.meta_email !== '' &&
                      <div className="contact mail">
                        <a href={'mailto:' + offer.company.meta_email}>{offer.company.meta_email}</a>
                      </div>
                    }

                    {offer.company.meta_link !== '' &&
                      <div className="contact link">
                        <a target="_blank" href={toolHelper.fix_https_url(offer.company.meta_link)}>{toolHelper.retrieve_domain_url(offer.company.meta_link)}</a>
                      </div>
                    }
                  </div>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 col-md-6">
              <div className="opening-hours">
                <h3>{translate('companybranding.opening_hours')}</h3>
                <ul className="col-md-9 col-sm-10 col-xs-12">
                  {openingHours.map( (item, i) => {
                    if( !item || item === '' || item === undefined || item === 'undefined' ) return null;
                    let itemSplit = item.split(',');
                    if( !itemSplit[0] || !itemSplit[1] || !itemSplit[2] ) return null;
                    return (
                      <li className={parseInt(itemSplit[0], 10) === current_day_number ? 'today' : ''} key={i}>
                        <p dangerouslySetInnerHTML={{__html: itemSplit[1] + ' ' + (parseInt(itemSplit[0], 10) === current_day_number ? '<span>(' + translate('common.today') + ')</span>' : '') + ' <span class="pull-right">' + itemSplit[2] + '</span>' }} />
                      </li>
                    )
                  })}
                </ul>
                <div className="clearfix"></div>
              </div>
            </div>
            <div className="clearfix"></div>
          </section>

          <section className="agent-info">
            <div className="top-bar">
              <div className="title-msg text-center">{translate('companybranding.your_insurance_offer')}</div>
            </div>

            <div className="col-xs-12 col-sm-6 col-md-6">
              {offer.starfish_company_id !== null &&
                <div className="row">
                  <div className="col-xs-12">
                    {offer.starfish_company.avatar_attached &&
                      <img src={urlHelper.imageUrl(offer.starfish_company.avatar_original)} alt={offer.starfish_company.name} className="img-responsive agent-avatar" />
                    }
                  </div>

                  <div className="agent-content col-xs-12">
                    <div className="name">
                      {offer.starfish_company.name}
                    </div>

                    <div className="assigned-to-you">
                      {translate('companybranding.assigned_agent_to_you')}
                    </div>

                    {(offer.starfish_company.phone !== '' && offer.starfish_company.phone !== null) &&
                      <div className="contact tel">
                        <a href={'tel:' + offer.starfish_company.phone}>
                          <i className="fa fa-phone"></i>
                          {offer.starfish_company.phone}
                        </a>
                      </div>
                    }

                    {(offer.starfish_company.email !== '' && offer.starfish_company.email !== null) &&
                      <div className="contact mail">
                        <a href={'mailto:' + offer.starfish_company.email}>
                          <i className="fa fa-envelope"></i>
                          {offer.starfish_company.email}
                        </a>
                      </div>
                    }

                  </div>

                  <div className="clearfix"></div>
                </div>
              }
              {offer.starfish_company_id === null &&
                <div className="row">
                  <div className="col-xs-12">
                    <img src={company_logo} alt={offer.company.name} className="img-responsive agent-avatar" />
                  </div>

                  <div className="agent-content col-xs-12">
                    <div className="name">
                      {offer.company.meta_name}
                    </div>
                  </div>

                  <div className="clearfix"></div>
                </div>
              }

              {app && appCompany && appCompany.direct_offer && <div className="col-lg-12 c-branding--offer">
                <DirectOffer
                  directOffer={appCompany.direct_offer}
                  applicationCompanyId={appCompany.id}
                  createDirectOfferStat={this._createDirectOfferStat}
                  translate={translate} />
              </div>}

            </div>
            <div className="clearfix visible-xs visible-sm"></div>

            <div className="col-md-6">
              <div className="activity-log">
                <h3>{translate('companybranding.company_activities')}</h3>
                <div className="log-holder">
                  {this.activity_logs.map( (item, i) => {
                    let formattedDate = moment(item.created_at).format(translate('common.date_output'));
                    return (
                      <div className="entry" key={i}>
                        <div className="row">
                          <div className="icony col-xs-1">
                            <i className={item.look}></i>
                          </div>
                          <div className="col-xs-10 status2">
                            {item.translated_activity}
                          </div>
                          <div className="created-at col-xs-offset-1 col-xs-11">
                            {formattedDate}
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <div className="clearfix"></div>


            {offer.upload_attachments.length > 0 &&
              <div className="col-md-3">
                <div className="act-buttons">
                  <Link onClick={this._getFile.bind(this)} data-filehash={offer.upload_attachments[0].file_hash} to='#' target='_blank' className='btn btn-success btn-sm' data-download='true'>
                    <i className="glyphicon glyphicon-download-alt"></i>
                    <span>{translate('companybranding.buttons.download_offer')}</span>
                  </Link>
                  <i className='fa fa-cog fa-spin'></i>
                </div>
              </div>
            }
            <div className="clearfix"></div>
          </section>

          {(!offer.upload_attachments.length || offer.upload_attachments[0].uploaded_by !== 'company') &&
          <section className="more-info-after col-md-6 col-md-offset-3">
            <div className="col-xs-12">
                <div>
                  <p><small>{translate('companybranding.add_offer_hint')}</small></p>

                  <div className="h-upload bordered">
                    <div className="upload-area">
                      <Dropzone
                        accept="image/png,image/jpg,image/jpeg,application/pdf"
                        disablePreview={true}
                        className="drop-box"
                        multiple={false}
                        activeClassName="dragover"
                        onDrop={this._handleFileUpload}>
                        <p className="hint-text">{translate('common.file_upload.hint_text_click_here')}</p>
                        <i className="fa fa-cog fa-spin"></i>
                      </Dropzone>

                      {(accepted !== null && accepted.original && accepted.original.name)  &&
                        <ul>
                          <li className="upload-ok">{accepted.original.name}</li>
                        </ul>
                      }
                    </div>
                  </div>
                </div>


            </div>
            <div className="clearfix"></div>
          </section>
          }
          <div className="clearfix"></div>
        </div>
        }
        {loading &&
          <div className='row text-center loading-container'>
            <ReactLoading type='spin' height='34px' width='34px' color='#8bb91d' className='loading-icon inline-centered' />
          </div>
        }
      </div>
    );
  }

  _mapOfferToState = () => {
    const { dispatch, translate, history } = this.props;

    dispatch(getOfferView(this.offer_company_id)).then(res => {
      if (res.status === 200 && res.data.status === undefined) {
        this.setState({ offer: { loading: false, row: res.data } });

        // Set navigation override title on the top
        dispatch(setTitle(translate('companybranding.about_company', { company: res.data.offer.company.meta_name })));
      } else {
        history.push('/');
      }
    });
  }

  _getFile = (e: any) => {
    e.preventDefault();

    const { currentTarget } = e;
    const { dispatch, translate} = this.props;

    // Reset flash messages
    dispatch(clearFlash());

    // - File hash
    // - Download file or just preview it?
    const { filehash, download } = currentTarget.dataset;
    // Show / hide loading bar
    this._loadingSpinner('show', 'inline-block', '.act-buttons .fa.fa-cog');

    getFile(filehash).then(res => {
      const { status, data } = res;
      if( status !== 200 || data.status === false ) return false;
      this._loadingSpinner('hide', 'inline-block', '.act-buttons .fa.fa-cog');

      window.open(window.URL_API_URL + '/starfish_users_attachments/preview/?file=' + filehash + '&token=' + data.token + '&download=' + download, '_blank');
    }).catch(res => {
      this._loadingSpinner('hide', 'inline-block', '.act-buttons .fa.fa-cog');
      if( res.response.status === 404 ) {
        dispatch(setFlash(translate('common.error.file.not_exist'), 'danger'));
      } else {
        dispatch(setFlash(translate('common.error.server'), 'danger'));
      }
    });
  }

  _handleFileUpload = (accepted: any, rejected: any) => {
    const { dispatch, translate } = this.props;

    // Reset flash messages
    dispatch(clearFlash());

    let lock_upload = false,
        fileData    = null;

    // If there is no file, do nothing
    if( !accepted.length || lock_upload === true ) {
      dispatch(setFlash(translate('common.error.file_upload.format'), 'danger'));
      this._loadingSpinner('hide');
      lock_upload = false;
      return false;
    }

    // Show loading spin
    this._loadingSpinner('show');

    lock_upload = true;
    let file = accepted[0];
    // File extension
    let file_ext = toolHelper.get_file_ext(file.name);
    // File name
    let file_name = file.name.replace('.' + file_ext, '');
    if( file_name === '' ) return false;
    file_name     = toolHelper.get_file_name_safe(file_name);
    // File key
    let file_key = new Date();
    file_key     = '_' + file_key.getTime();
    // Bucket
    let bucket = window.S3BUCKET;
    // Application Company ID
    let applicationCompanyID = Number(this.applicationCompanyID);

    // STEP 1: Get creds for data save to Amazon S3
    dispatch(getCreds(file_name, file_key, '.' + file_ext, bucket)).then(res => {
      const { data, status } = res;

      if( status === 200 && data.success_action_status === '201' ) {
        fileData = data;

        if( fileData.filename === '' ) return false;

        let prepareDataForm = new FormData();
        prepareDataForm.append('key', data.key + data.filename);
        prepareDataForm.append('AWSAccessKeyId', data.AWSAccessKeyId);
        prepareDataForm.append('acl', data.acl);
        prepareDataForm.append('success_action_status', data.success_action_status);
        prepareDataForm.append('policy',data.policy);
        prepareDataForm.append('signature', data.signature);
        prepareDataForm.append('Content-Type', data.content_type);
        prepareDataForm.append('filename', data.filename);
        prepareDataForm.append('file', file);
        prepareDataForm.append('fileName', data.filename);

        // STEP 2: Upload file to S3 Amazon bucket
        uploadFile(bucket, prepareDataForm).then(res => {
          const { status } = res;
          if( status !== 201 ) {
            dispatch(setFlash(translate('common.error.file_upload.amazon'), 'danger'));
            this._loadingSpinner('hide');
            lock_upload = false;
            return false;
          }

          // STEP 3: Create attachment record on rails
          let data_send = {
            file_name: (fileData && fileData.filename ? fileData.filename : ''),
            file_hash: (fileData && fileData.signature ? fileData.signature : ''),
            file_type: (fileData && fileData.content_type ? fileData.content_type : ''),
            bucket: bucket,
            application_id: 0,
            application_company_id: applicationCompanyID,
            uploaded_by: 'user'
          };

          saveAttachment(data_send).then(res => {
            const { status } = res;
            this._loadingSpinner('hide');
            lock_upload = false;

            if( status !== 200 ) {
              dispatch(setFlash(translate('common.error.file_upload.error'), 'danger'));
              return false;
            };

            if( fileData ) {
              fileData['original'] = file;
            }

            this.setState({
              dropzone: Object.assign({}, this.state.dropzone, {
                accepted: fileData
              })
            });

            // Reinit offer
            this._mapOfferToState();
          });
        });
      } else {
        dispatch(setFlash(translate('common.error.file_upload.s3policy'), 'danger'));
        this._loadingSpinner('hide');
        lock_upload = false;
      }
    });
  }

  _loadingSpinner = (type: string = '', display: string = 'block', selector: string = '') => {
    let loadingSpinner = selector !== '' ? document.querySelectorAll(selector)[0] : document.querySelectorAll('.upload-area .fa')[0];
    if( type === 'show' ) {
      loadingSpinner.style.display = display;
    } else {
      loadingSpinner.style.display = 'none';
    }
  }

  _offerStatusCheck = (status: string) => {
    return this.state.offer.row.offer.primary_webservice_status.status === status;
  }

  _renderUSPList(uniqueSellingPoints, offer) {
    return(
      <div className="unique-selling-point-box">
        {uniqueSellingPoints.map( (item, i) => {
          if( !item || item === '' ) return null;
            return(
              <div key={i}>
                <div className="unique-selling-point" style={{color: offer.company.meta_brand_color}}>
                  <p dangerouslySetInnerHTML={{__html: item}}></p>
                </div>
              </div>
            )
          }
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  translate     : getTranslate(state.locale),
  user          : state.user,
  currentApp    : state.application
});

export default connect(mapStateToProps)(CompanyBranding);



// WEBPACK FOOTER //
// ./src/components/main/CompanyBranding/index.js